import * as OrderActions from '../Constants/index';

export const setOrders = (payload) => {
    return {
        type:OrderActions.SET_ORDERS,
        data:payload
    }
}

export const setOrdersOwnerKey = (payload) => {
    return {
        type:OrderActions.SET_ORDERS_OWNER_KEY,
        data:payload
    }
}

export const setOrdersScrollTop = (payload) => {
    return {
        type:OrderActions.SET_ORDERS_SCROLL_TOP,
        data:payload
    }
}

export const setOrdersFilters = (payload) => {
    return {
        type:OrderActions.SET_ORDERS_FILTERS,
        data:payload
    }
}

export const setLimitReached = (payload) => {
    return {
        type:OrderActions.SET_LIMIT_REACHED,
        data:payload
    }
}

export const clearState = (payload) => {
    return {
        type:OrderActions.CLEAR_STATE,
        data:payload
    }
}
